import { useState } from 'react';
import { Link } from 'react-router-dom';
import { productosData } from '../data/productos';
import './Productos.css';

const Productos = () => {
  // Estados para los filtros
  const [busqueda, setBusqueda] = useState('');
  const [filtroMaduracion, setFiltroMaduracion] = useState('');
  const [filtroTamano, setFiltroTamano] = useState('');

  //Estado para el catálogo del celular
  const [mostrarFiltros, setMostrarFiltros] = useState(false);

  // Lógica de filtrado dinámico
  const productosFiltrados = productosData.filter((producto) => {
    // 1. Filtro por nombre
    const coincideNombre = producto.nombre.toLowerCase().includes(busqueda.toLowerCase());
    
    // 2. Filtro por maduración
    const coincideMaduracion = filtroMaduracion === '' || producto.maduracion === filtroMaduracion;
    
    // 3. Filtro por tamaño (buscamos dentro del array de opciones si existe)
    const coincideTamano = filtroTamano === '' || 
      (producto.opciones && producto.opciones.some(opcion => opcion.id === filtroTamano));

    // Solo mostramos el producto si pasa TODOS los filtros activos
    return coincideNombre && coincideMaduracion && coincideTamano;
  });

  // Función para mostrar el precio base ("Desde $...")
  const obtenerPrecioBase = (producto) => {
    if (producto.opciones && producto.opciones.length > 0) {
      // Ordenamos para mostrar siempre el precio más barato
      const precios = producto.opciones.map(op => op.precio);
      const precioMinimo = Math.min(...precios);
      return `Desde $ ${precioMinimo.toLocaleString('es-AR')}`;
    }
    return 'Consultar precio';
  };

  return (
    <div className="catalogo-container">
      {/* COLUMNA IZQUIERDA: Buscador y Filtros */}
      <button 
      className="btn-toggle-filtros"
      onClick={() => setMostrarFiltros(!mostrarFiltros)}
      >
      {mostrarFiltros ? "Ocultar filtros" : "Buscar productos"}
      </button>
      <aside className={`catalogo-sidebar ${mostrarFiltros ? "activo" : ""}`}>
        
        <div className="filtro-grupo">
          <label>Buscar por nombre</label>
          <input 
            type="text" 
            placeholder="Ej: Gouda, Saborizado..." 
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
          />
        </div>

        <div className="filtro-grupo">
          <label>Maduración</label>
          <select 
            value={filtroMaduracion} 
            onChange={(e) => setFiltroMaduracion(e.target.value)}
          >
            <option value="">Todas</option>
            <option value="30 días">30 días</option>
            <option value="60 días">60 días</option>
            <option value="3 meses">3 meses</option>
            <option value="6 meses">6 meses</option>
          </select>
        </div>

        <div className="filtro-grupo">
          <label>Tamaño disponible</label>
          <select 
            value={filtroTamano} 
            onChange={(e) => setFiltroTamano(e.target.value)}
          >
            <option value="">Todos los tamaños</option>
            <option value="porcion">Porción</option>
            <option value="media_horma">Media Horma</option>
            <option value="barra">Barra</option>
            <option value="horma">Horma</option>
          </select>
        </div>
        
        <button 
          className="btn-limpiar"
          onClick={() => {
            setBusqueda(''); setFiltroMaduracion(''); setFiltroTamano('');
          }}
        >
          Limpiar filtros
        </button>
      </aside>

      {/* COLUMNA DERECHA: Grilla de Productos */}
      <main className="catalogo-main">
        <h2 className="catalogo-titulo">Catálogo</h2>
        
        {productosFiltrados.length === 0 ? (
          <p className="no-resultados">No se encontraron productos con esos filtros.</p>
        ) : (
          <div className="productos-grilla">
            {productosFiltrados.map((producto) => (
              <div key={producto.id} className="producto-tarjeta-simple">
                <Link to={`/productos/${producto.id}`}>
                  <img src={producto.imagen} alt={producto.nombre} />
                </Link>
                <div className="tarjeta-info">
                  <Link to={`/productos/${producto.id}`} className="tarjeta-titulo">
                    <h4>{producto.nombre}</h4>
                  </Link>
                  <p className="tarjeta-precio">{obtenerPrecioBase(producto)}</p>
                  <Link to={`/productos/${producto.id}`} className="btn-ver-detalle">
                    Ver detalle
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default Productos;